import React from 'react';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { List } from 'immutable';
import {
  connect,
  ApiCall,
  ApiResponseHelper,
  ApiResponse,
  testClass,
  Grid,
} from 'omni-common-ui';

import {
  actions as fetchStudentReportSummaryActions,
} from 'data/ProgressReports/StudentReportSummaries';
import { actions as GroupMembers } from 'data/GroupMembers';
import UnsavedChangesTrackingPageComponent from 'components/UnsavedChangesTrackingPageComponent';
import UnsavedChangesWarning from 'components/UnsavedChangesWarning';
import NoContentMessage from 'components/NoContentMessage';
import DosApprovalCard from './DosApprovalCard';
import PropTypes from 'prop-types';

const FILTER_BY_REPORT_STATUS = 'SentToDoS';

class DosApprovalList extends UnsavedChangesTrackingPageComponent {
  componentWillMount() {
    const { fetchStudentReportSummaries, approvalList, params } = this.props;
    const { progressReportId } = params;
    if (ApiResponseHelper.shouldFetch(approvalList)) {
      fetchStudentReportSummaries(progressReportId);
    }
    this.setState({
      cardsInEditingModeCount: 0,
      shouldTriggerSaveAllComments: false,
      isAnyCommentChanged: false,
    });
    super.componentWillMount();
  }

  componentWillReceiveProps() {
    this.setState({
      cardsInEditingModeCount: 0,
      shouldTriggerSaveAllComments: false,
      isAnyCommentChanged: false,
    });
  }

  _isChangesPresent() {
    return this.state.cardsInEditingModeCount > 0 &&
        this.state.isAnyCommentChanged;
  }

  _onCardEnterOrLeaveEditMode(isLeaving) {
    const inc = isLeaving ? - 1 : 1;
    this.setState(({ cardsInEditingModeCount }) => ({
      cardsInEditingModeCount: cardsInEditingModeCount + inc,
    }));
  }

  _renderCards() {
    const { approvalList, approvalListForGroup, params } = this.props;
    const { progressReportId } = params;

    if (! ApiResponseHelper.hasSucceeded(approvalList)) {
      return null;
    }

    if (approvalListForGroup.size === 0) {
      return <NoContentMessage className={testClass('empty')}
          text="There are no reports waiting for approval at this time." />;
    }

    return <Grid>
      <Grid.Group>
        {
          approvalListForGroup.map((studentReport) =>
            <DosApprovalCard key={studentReport.id}
                groupId={params.groupId}
                progressReportId={progressReportId}
                studentId={studentReport.studentId}
                buildRoute={this.props.buildRoute}
                location={this.props.location}
                shouldTriggerSaveAllComments={this.state.shouldTriggerSaveAllComments}
                onEnterEditMode={() => {
                  this._onCardEnterOrLeaveEditMode();
                }}
                onLeaveEditMode={() => {
                  this._onCardEnterOrLeaveEditMode(true);
                }}
                onCommentChanged={() => {
                  this.state.isAnyCommentChanged || this.setState({
                    isAnyCommentChanged: true,
                  });
                }} />
          ).toArray()
        }
      </Grid.Group>
    </Grid>;
  }

  _renderUnsavedChangesWarningDialog() {
    return <UnsavedChangesWarning isOpen={
          !! this._isNavigationWithChangesRequested()}
        isSaving={this.props.isAnyApiCallSaving}
        onDiscardClicked={() => {
          this._forcePushRequestedLocation();
        }}
        onCloseClicked={() => {
          this._clearRequestedLocation();
        }}
        onSaveClicked={() => {
          this.setState({ shouldTriggerSaveAllComments: true });
        }}
        onSaved={() => {
          this._forcePushRequestedLocation();
        }} />;
  }

  render() {
    return <div>
      {this._renderCards()}
      {this._renderUnsavedChangesWarningDialog()}
    </div>;
  }
}

DosApprovalList.propTypes = {
  fetchStudentReportSummaries: PropTypes.func.isRequired,
  approvalList: PropTypes.instanceOf(ApiResponse),
  approvalListForGroup: PropTypes.objectOf(List),
  params: PropTypes.shape({
    progressReportId: PropTypes.string.isRequired,
    groupId: PropTypes.string.isRequired,
  }).isRequired,
  location: PropTypes.object.isRequired,
  pushRoute: PropTypes.func.isRequired,
  buildRoute: PropTypes.func.isRequired,
  isAnyApiCallSaving: PropTypes.bool,
  route: PropTypes.any.isRequired,
  router: PropTypes.any.isRequired,
};

function mapStateToProps(state, { params }) {
  const { progressReportId } = params;

  const groupMemberIds =
      GroupMembers.getMembersByGroup(state, params.groupId)
      .map((member) => member.studentGeneralInfo.id);

  const approvalList = state.get('rootReducer')
      .get('studentReportSummaries')
      .get(progressReportId);

  // we might have students who aren't in our group. filter them out.
  // we'll also take the reports with a status of "SentToDoS" here.
  let approvalListForGroup = null;
  if (ApiResponseHelper.hasSucceeded(approvalList)) {
    approvalListForGroup =
        approvalList.update('data', (data) =>
          data.filter((sr) => sr.status === FILTER_BY_REPORT_STATUS &&
            groupMemberIds.indexOf(sr.studentId) !== - 1))
        .data;
  }

  return {
    approvalList,
    approvalListForGroup,
    isAnyApiCallSaving: !! isAnyApiCallSaving(state),
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({ pushRoute: (path) => dispatch(push(path)) },
      bindActionCreators(fetchStudentReportSummaryActions, dispatch));
}

function isAnyApiCallSaving(state) {
  return !! (state.get('apiCalls') || new List())
    .filter((call, key) =>
      ['PUT', 'POST'].some((method) => key.startsWith(method)))
    .find((call) => ApiCall.State.isLoading(call));
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DosApprovalList));



// WEBPACK FOOTER //
// ./containers/Group/ProgressReport/DosApprovalList/component.jsx